<template>
  <v-container class="cmp-catalog-artists-sidewindow dt-sidewindow">
    <div class="dt-tabs-container">
      <div class="dt-details2">
        <div class="dt-details--header">
          <div
            class="title"
            :title="
              selectedArtistDetails &&
                selectedArtistDetails.artist &&
                selectedArtistDetails.artist.artist_name
            "
          >
            <span>{{
              (selectedArtistDetails &&
                selectedArtistDetails.artist &&
                selectedArtistDetails.artist.artist_name) ||
                $t('artist_name')
            }}</span>
          </div>
        </div>
        <div class="dt-details--body">
          <div class="dt-details--col">
            <div class="ut-flex">
              <div>
                {{
                  (selectedArtistDetails &&
                    selectedArtistDetails.artist &&
                    selectedArtistDetails.artist.sort_name) ||
                    $t('release_artist')
                }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <glayout
        :tabs="catalogartistsSidewindowTabs"
        :loading="selectedArtistDetails && selectedArtistDetails.loading"
      >
        <gtab>
          <grow>
            <gcol>
              <!-- <gbox :title="$t('artist_setup')" h="228"> -->
              <gbox
                :title="`${$t('artist')} ${$t('tab_title_main_setup')}`"
                h="227"
              >
                <ArtistSetup
                  @changed="onArtistUpdate"
                  :selectedArtistDetails="selectedArtistDetails"
                />
              </gbox>
              <gbox
                :h="
                  boxHeight(
                    selectedArtistDetails &&
                      selectedArtistDetails.contact_relations &&
                      selectedArtistDetails.contact_relations.length,
                    NTOffsets.WithHeaderDBoxBottom
                  )
                "
                :title="$t('related_contacts')"
              >
                <RealtedContacts
                  v-if="selectedArtistDetails"
                  :contact_relations="selectedArtistDetails.contact_relations"
                  :external_id="
                    `${selectedArtistDetails.artist.label_artist_id}`
                  "
                  :external_table="'label_artist'"
                  @delete="onRelatedContactDelete"
                  @changed="onRelatedContactChange"
                  @contact_selected="onRelatedContactSelected"
                />
              </gbox>
              <gbox :title="$t('notes')" bc="var(--bc-note)">
                <DBoxTextarea
                  :value="selectedArtistDetails.artist.notes"
                  :id="'notes'"
                  @blur="
                    e =>
                      onArtistUpdate({
                        name: 'notes',
                        value: e.target.value
                      })
                  "
                />
              </gbox>
            </gcol>
            <gcol>
              <gbox
                :h="
                  boxHeight(
                    selectedArtistDetails &&
                      selectedArtistDetails.related_releases &&
                      selectedArtistDetails.related_releases.length,
                    NTOffsets.WithHeaderDBoxBottom
                  )
                "
                :title="$t('autobalance_release_ids')"
              >
                <RelatedRelease
                  :selectedArtistDetails="selectedArtistDetails"
                  @delete="onDeleteRelease"
                />
              </gbox>
              <gbox
                :h="
                  boxHeight(
                    selectedArtistDetails &&
                      selectedArtistDetails.default_credits &&
                      selectedArtistDetails.default_credits.length,
                    NTOffsets.WithHeaderDBoxBottom
                  )
                "
                :title="$t('default_credits')"
              >
                <DefaultCredit
                  :selectedArtistDetails="selectedArtistDetails"
                  @delete="onDeleteCredit"
                />
              </gbox>
            </gcol>
          </grow>
        </gtab>
        <gtab id="info">
          <grow>
            <gcol>
              <gbox :title="$t('artist_info_english')">
                <DBoxTextarea
                  :id="'bio_engl'"
                  :value="selectedArtistDetails.artist.bio_engl"
                  :style="{ backgroundColor: 'white' }"
                  @blur="
                    e =>
                      onArtistUpdate({
                        name: 'bio_engl',
                        value: e.target.value
                      })
                  "
                />
              </gbox>
              <gbox
                :h="
                  boxHeight(
                    selectedArtistDetails &&
                      selectedArtistDetails.files &&
                      selectedArtistDetails.files.length,
                    NTOffsets.WithDBoxBottom
                  )
                "
                :title="$t('related_documents')"
              >
                <DBoxFiles
                  :files="selectedArtistDetails.files"
                  :externalId="`${this.label_artist_id}`"
                  :externalTable="'artist'"
                />
              </gbox>
            </gcol>
            <gcol>
              <gbox
                :title="
                  `${$t('artist')} ${$t('info')} ${$t(
                    'second_language_string'
                  )}`
                "
              >
                <DBoxTextarea
                  :id="'bio_own'"
                  :value="selectedArtistDetails.artist.bio_own"
                  :style="{ backgroundColor: 'white' }"
                  @blur="
                    e =>
                      onArtistUpdate({
                        name: 'bio_own',
                        value: e.target.value
                      })
                  "
                />
              </gbox>
              <gbox h="308" :title="`${$t('artist')} ${$t('pictures_string')}`">
                <Artwork
                  :artwork1="selectedArtistDetails.artwork1"
                  :artwork2="selectedArtistDetails.artwork2"
                  :externalId="`${this.label_artist_id}`"
                  :externalTable="'artists'"
                  :externalKey="'label_artist_id'"
                  :section="'artists'"
                  @artworkChanged="onArtworkChanged"
                  @done="onArtworkUploadDone"
                />
              </gbox>
            </gcol>
          </grow>
        </gtab>
        <gtab id="metadata">
          <grow>
            <gcol>
              
              <gbox 
                :h="boxHeight(
                  selectedArtistDetails &&
                      selectedArtistDetails.all_item_metadata &&
                      selectedArtistDetails.all_item_metadata.length ,
                    NTOffsets.WithHeader
                  )" 
                :title="$t('metadata')">
                <Metadata
                  @changed="onMetaDataUpdate"
                  :detailsObject="selectedArtistDetails"
                />
              </gbox>
            </gcol>
            <gcol> </gcol>
          </grow>
        </gtab>
      </glayout>
    </div>

    <ModalContainer
      :modalKey="'addDefaultCredit'"
      :width="'small'"
      @cancelled="onCancel"
    >
      <DefaultCreditModal @create="createDefaultCredit" @cancelled="onCancel" />
    </ModalContainer>

    <ModalContainer
      :modalKey="'addReleaseModal'"
      :width="'small'"
      @cancelled="onCancel"
    >
      <AddReleaseModal @cancelled="onCancel" @create="onReleaseAdd" />
    </ModalContainer>

    <ModalContainer
      :modalKey="'addBookingArtistModal'"
      :width="'small'"
      @cancelled="onCancel"
    >
      <AddBookingArtistModal @create="onArtistAdd" @cancelled="onCancel" />
    </ModalContainer>
  </v-container>
</template>

<script>
import DBoxTextarea from "../../../../dt-plugins/dbox-textarea/dbox-textarea";
import * as ActionTypes from "../../store/types";
import BoxWidget from "@plugins/box-widget/box-widget";
import DBoxFiles from "@/dt-plugins/dbox-files/dbox-files";

import AddBookingArtistModal from "./add-booking-artist-modal";

import { mapGetterObject, mapActionObject } from "../../../../store/global";

import { openWindow } from "../../../../utility";
import {
  getBaseUrl,
  HttpClient,
  MHTTPCL
} from "../../../../services/http/http-client";
import { catalogArtistListLDTRoutes } from "../../router/routes";
import { checkTabListPermission } from "../../../../router/guard";

import { createModalMixin } from "../../../../dt-plugins/modal/modal.mixin";
import ModalContainer from "@dtplugins/modal/modal-container";
import { tv } from "../../../../models/text-value.model";
import { createCurrencyTV } from "../../../../models/currency.model";
import { createLanguageTV } from "../../../../models/language.model";
import { createUserTV } from "../../../../models/user.model";

import { artistsCatalogGetters } from "../../store/artists/getters";
import { artistsCatalogActions } from "../../store/artists/actions";
import { CatalogStoreNamespace as storeNS } from "../../store";
import { mapGetters, mapActions } from "vuex";
import { pathOr } from "ramda";

//grid component

import ArtistSetup from "./artist-setup";
import RealtedContacts from "@/dt-plugins/add-contact-relation/related-contacts";
import DefaultCredit from "./default-credit";
import RelatedRelease from "./related-release";
import AddReleaseModal from "./add-release-modal";

//Modal Comp

import DefaultCreditModal from "./default-credit-modal";
import RelatedBookings from "./related-bookings";

import { format, formatDistance, formatRelative, subDays } from "date-fns";
import { DISTRIBUTION_URL } from "../../../../services/common-urls";
import DList from "../../../../dt-plugins/list/dlist";
import Artwork from "@dtplugins/artwork/artwork";
import Metadata from "@dtplugins/metadata/metadata";
import { createDTGridHost } from "../../../../dt-plugins/dt-grid/dt-grid.mixin";
export const moduleRoute = "catalog";
export const submenuRoute = "catalog_artists";

export default {
  components: {
    BoxWidget,
    DBoxTextarea,
    ModalContainer,

    ArtistSetup,
    RealtedContacts,
    DefaultCredit,
    DBoxTextarea,
    DBoxFiles,
    Artwork,
    Metadata,
    RelatedBookings,
    DList,
    RelatedRelease,
    DefaultCreditModal,
    AddReleaseModal,
    AddBookingArtistModal
    // Sidewindow,
    // InvoiceLinesForward,
  },
  props: {},
  mounted: function() {
    console.log("WEREEERRRR", this.selectedArtistDetails);
  },
  data: function() {
    return {
      active: -1,

      lockLoading: false,
      formatDate: format(new Date(), "YYYY-MM-DD HH:MM:SS")
    };
  },
  mixins: [
    createDTGridHost(),
    createModalMixin("addReleaseModal"),
    createModalMixin("addDefaultCredit"),
    createModalMixin("addBookingArtistModal")
  ],

  computed: {
    ...mapGetterObject(storeNS, artistsCatalogGetters),

    catalogartistsSidewindowTabs: function() {
      return checkTabListPermission(moduleRoute, submenuRoute, [
        {
          route: "overview",
          value: this.$t("tab_title_invoice_info")
        },
        {
          route: "info",
          value: this.$t("info")
        },
        // {
        //   route: "tab_title_bookings",
        //   value: this.$t("tab_title_bookings"),
        //   vgi_id: "tab_title_bookings",
        // },
        {
          route: "metadata",
          value: this.$t("metadata")
        }
      ]);
    },

    label_artist_id: function() {
      return this.$route.params.label_artist_id;
    },

    metaDataLength:function(){
       const mappedEndPoints = this.selectedArtistDetails.all_item_metadata_endpoints.map(element => {
        return element.metadata_endpoint
        
      });
   

      const metaDataArray = this.selectedArtistDetails.all_item_metadata.filter(
            (e) => mappedEndPoints.includes(e.metadata_endpoint) 
          ).map((x,index)=>{
            return{
              ...x,
              index
            }
          })||[];

      return metaDataArray.length + mappedEndPoints.length-1;
    },

    selectedArtistDetails: function() {
      const selectedArtistDetails =
        (this.artistDetails || {})[this.label_artist_id] || {};
      const artist = selectedArtistDetails.artist || {};
      console.log(
        "BASE URL",
        getBaseUrl() + "/files.pl?action=show_file&file_id=" + artist.artwork1
      );

      // const artwork1 = getBaseUrl()+"/files.pl?action=show_file&file_id="+ artist.artwork1;
      // const artwork2 = getBaseUrl()+"/files.pl?action=show_file&file_id="+ artist.artwork2;

      const contact_relations = selectedArtistDetails.contact_relations || [];
      const related_releases = selectedArtistDetails.related_releases || [];
      const default_credits = selectedArtistDetails.default_credits || [];

      const all_item_metadata = selectedArtistDetails?.all_item_metadata ||[];

      const all_item_metadata_endpoints = selectedArtistDetails?.all_item_metadata_endpoints ||[];
      console.log(
        "DETAILS",
        this.artistDetails,
        selectedArtistDetails,
        this.label_artist_id
      );

      return {
        ...selectedArtistDetails,
        artist,
        // artwork1,
        // artwork2,
        contact_relations,
        related_releases,
        default_credits,
        all_item_metadata,
        all_item_metadata_endpoints
      };
    }

    //NEED TO CLEAN UP
    // MARK: Methods
  },
  methods: {
    ...mapActionObject(storeNS, artistsCatalogActions),
    onReleaseTextboxBlur: function(name, value) {
      const payload = {
        name: name,
        value: value,
        table: "l_releases"
      };
    },
    onReleaseAdd: function(payload) {
      this[ActionTypes.CatalogRelease.INSERT.SINGLE]({
        ...payload,
        artist: this.selectedArtistDetails
      });
      this.onCancel();
    },
    onArtistUpdate: function(payload) {
      console.log(payload);
      this[ActionTypes.CatalogArtistsDetails.UPDATE.SINGLE]({
        ...payload,
        item: this.selectedArtistDetails
      });
    },
    onRelatedContactDelete: function(contact) {
      this[ActionTypes.ArtistRelatedContacts.DELETE.SINGLE]({
        contact,
        artist: this.selectedArtistDetails
      });
    },
    onRelatedContactSelected: function() {},
    onRelatedContactChange: function() {},
    onCancel: function() {
      this.$router.push({
        query: {
          modal: undefined,
          external_id: undefined
        }
      });
    },
    createDefaultCredit: function(payload) {
      this[ActionTypes.DefaultCredit.INSERT.SINGLE]({
        ...payload,
        artist: this.selectedArtistDetails
      });
      this.onCancel();
    },

    onDeleteCredit: function(payload) {
      this[ActionTypes.DefaultCredit.DELETE.SINGLE]({
        item: payload,
        artist: this.selectedArtistDetails
      });
    },

    onDeleteRelease: function(payload) {
      this[ActionTypes.CatalogRelease.DELETE.SINGLE]({
        ...payload,
        artist: this.selectedArtistDetails
      });
    },

    onArtistAdd: function(payload) {
      this[ActionTypes.ArtistBookingArtist.INSERT.SINGLE]({
        ...payload,
        artist: this.selectedArtistDetails
      });
      this.onCancel();
    },

    addBookingArtistClick: function() {
      this.$router.push({
        query: {
          modal: "add_booking_artist_modal",
          external_id: this.label_artist_id
        }
      });
    },
    onBookingArtistDelete: function(payload) {
      console.log(payload);
      this[ActionTypes.ArtistBookingArtist.DELETE.SINGLE]({
        ...payload,
        artist: this.selectedArtistDetails
      });
    },
    onBookingArtistClick: function() {},
    onArtworkChanged: function(payload) {
      this[ActionTypes.SET_ARTIST_ARTWORK]({
        ...payload,
        selectedArtistDetails: this.selectedArtistDetails
      });
    },
    onArtworkUploadDone: function(payload) {
      this[ActionTypes.SET_ARTIST_ARTWORK]({
        ...payload,
        selectedArtistDetails: this.selectedArtistDetails
      });
      this[ActionTypes.SET_ARTIST_PRODUCT_FILES]({
        ...payload,
        selectedArtistDetails: this.selectedArtistDetails
      });
    },

    onMetaDataUpdate: function(payload) {
      console.log("ONUPDATE", payload);
      this[ActionTypes.ArtistMetaData.UPDATE.SINGLE]({
        ...payload,
        item: this.selectedArtistDetails.artist
      });
    }
  }
};
</script>
<style lang="scss">
.cmp-catalog-artists-sidewindow {
  .flex-container {
    display: flex;
  }
  .dt-grid-layout {
    height: calc(100vh - 150px);
  }
  .overview-options {
    margin-top: 7%;
    .icons {
      display: flex;
      justify-content: center;
      img:first-child {
        padding-top: 2px;
      }
      img {
        cursor: pointer;
      }
      .loading-icon-container {
        width: 30px;
        .loading-icon {
          width: 15px;
          height: 15px;
          padding-left: 5px;
        }
      }

      .status {
        margin-top: 17px;
        margin-left: 5px;
        .circle {
          width: 15px;
          height: 15px;
          border-radius: 30px;
        }
      }
    }
  }
}
</style>
